<template>
    
    <div>
        <Dialog v-model:visible="visible" modal header="PE" :style="{ width: '50vw' }">

            <table v-for="d in droitsPe" :key="d.id">
                <tr>PE - {{ d.tot }} € - {{ d.payeur }}</tr>
                <tr>
                    <th>Date</th>
                    <th>Nature</th>
                    <th>montant</th>
                </tr>
                <tr>
                    <td>{{ new Date(d.date.date).toLocaleDateString('fr-FR') }}</td>
                    <td>{{ d.description }}</td>
                    <td>{{ d.ini }} €</td>
                </tr>
                <tr v-for="a in d.acptes" :key="a.id">
                    <td>{{ new Date(a.date.date).toLocaleDateString('fr-FR') }}</td>
                    <td>{{ a.description }}</td>
                    <td>{{ a.tot }} €</td>
                </tr>
            </table>

            <template #footer>
                <button @click="close">CLOSE</button>
            </template>
        </Dialog>
    </div>
</template>

<script>

export default {
    props: ["boolean", "droitPe", "acptePe"],

    whatch: {
        visible(newValue){
            this.$emit("cancelPeDetail", newValue);
        }
    },

    data() {
        return {
            visible : this.boolean,
            droitsPe : this.droitPe,
            acptesPe : this.acptePe,
        }
    },

    mounted() {
        this.calculTotDroits();
    },

    methods: {
        close(){
            this.visible = false;
            this.$emit("cancelPeDetail", false);
        },

        calculTotDroits(){
            this.droitsPe.forEach(d => {
                let totPe = 0;
                totPe = totPe + d.tot;

                d.acptes = [];

                this.acptesPe.forEach(a => {
                    if(d.id == a.doitsPeId){
                        totPe = totPe + a.tot;
                        d.acptes.push(a);
                    }
                })

                d.ini = totPe;

            });
        }
    },
}
</script>


<style scoped>
table {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

table td, table th {
  border: 1px solid #ddd;
  padding: 8px;
}

table tr:nth-child(even){background-color: #f2f2f2;}

table tr:hover {background-color: #ddd;}

table th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #07989f;
  color: white;
}
</style>